import { decode, encode, parseValue, stringifyValue } from '../StorageUtils';
import { StorageConfigInterface, StorageInterface, StorageType, StorageDataType } from '../types/storageTypes';

class TemporaryStorage implements StorageInterface {
  private options: StorageConfigInterface[StorageType.TEMPORARY];
  constructor(configurations: StorageConfigInterface[StorageType.TEMPORARY]) {
    this.options = configurations;
  }

  store(key: string, value: StorageDataType) {
    const transformedValue = this.options?.encryption ? encode(stringifyValue(value)) : stringifyValue(value);
    sessionStorage.setItem(key, transformedValue);
  }

  retrieve(key: string) {
    const value = sessionStorage.getItem(key);
    if (!value) {
      return value;
    }
    return parseValue(this.options?.encryption ? decode(value) : value);
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  clearStorage() {
    sessionStorage.clear();
  }
}

export default TemporaryStorage;
